declare module 'mocha.parallel';
